<template>
  <div>
    <div class="modal-table">
      <b-row>
        <b-col cols="4">
          <p class="text-header">Promocode Name</p>
        </b-col>
        <b-col cols="8">
          <div class="d-flex justify-content-end">
            <div class="g-form">
              <div class="input">
                <b-form-input
                  v-model="formSearch.promocodeSerialNo"
                  placeholder="Promocode SerialNo"
                  @focus="iconSearch = true"
                  @blur="iconSearch = false"
                  @keyup.enter="onClickHandleSearch"
                ></b-form-input>
                <b-button
                  class="search"
                  :class="iconSearch ? 'active-border' : ''"
                  @click="onClickHandleSearch"
                >
                  <b-icon
                    stacked
                    icon="search"
                    scale="0.5"
                    variant="grey"
                  ></b-icon>
                </b-button>
              </div>
            </div>

            <b-button class="btn-filter ml-2" @click="openSideBar">
              <span class="d-none d-md-block">
                <font-awesome-icon icon="filter" class="pointer" />
                <span class="btn-text">ตัวกรอง</span>
              </span>
            </b-button>

            <b-button
              class="btn-filter ml-2"
              @click="exportPromocodeGeneratedDetail"
            >
              ดาวน์โหลดข้อมูล
            </b-button>
          </div>
        </b-col>
      </b-row>

      <SideBarFilter
        :filter="filter"
        ref="sidebarCheckCode"
        placeholder="Promocode Name"
        @searchAll="onClickHandleSearch"
        @clearFilter="clearFilter"
        :hideStatusFilter="false"
        :hideSearchBar="true"
      >
        <template v-slot:filter-option>
          <div>
            <InputSelect
              v-model="formSearch.isUseStatus"
              :options="optionStatusPromocode"
              title="สถานะ"
              valueField="value"
              textField="text"
            />
          </div>
        </template>
      </SideBarFilter>
      <div class="body">
        <b-table
          responsive
          striped
          hover
          :fields="fields"
          :items="items"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="{ item }">
            <div v-if="item.isBlindAccount">{{ item.userName }}</div>
            <div v-else>
              <b-button
                class="btn-filter gold"
                :disabled="isBinding && item.id === selectedItem.id"
                @click="connectUser(item)"
              >
                <div class="d-flex justify-content-center align-items-center">
                  Connect
                  <b-spinner
                    v-if="isBinding && item.id === selectedItem.id"
                    class="align-middle ml-2"
                    small
                  ></b-spinner>
                </div>
              </b-button>
            </div>
          </template>
        </b-table>
        <Pagination
          @handleChangeTake="handleChangeTake"
          :pageOptions="pageOptions"
          :rows="rows"
          :filter="filter"
          @pagination="pagination"
        />
      </div>
    </div>

    <ModalUser
      ref="userModal"
      @select="handleSelectedCustomer"
      :selectedCustomer="selectedItem.userId"
      :showSaveBtn="false"
    />
    <ModalAlertText :textModal="textModal" :arrModal="[]" />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import ModalUser from "./component/modal/ModalUser.vue";
import ModalAlertText from "@/components/modal/ModalAlertText.vue";

export default {
  components: {
    Pagination,
    ModalUser,
    ModalAlertText,
  },
  data() {
    return {
      //state formSearch
      formSearch: {
        promocodeSerialNo: null,
        isUseStatus: null,
      },
      selectedItem: {
        userId: "",
      },

      //optionStatus Promocode
      optionStatusPromocode: [
        {
          value: null,
          text: "ทั้งหมด",
        },
        {
          value: false,
          text: "ยังไม่ถูกใช้งาน",
        },
        {
          value: true,
          text: "ใช้งานแล้ว",
        },
      ],
      textModal: "",

      // state table
      filter: {
        skip: 1,
        page: 1,
        take: 10,
      },
      items: [],
      fields: [
        {
          key: "promocodeSerialNo",
          label: "Promocode SerialNo",
          class: "w-100px text-nowrap",
        },
        {
          key: "isUseStatusString",
          label: "สถานะ",
          class: "w-100px text-nowrap",
        },

        { key: "actions", label: "User's Relation" },
      ],
      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      iconSearch: false,
      isBinding: false,
    };
  },
  created() {
    this.getPromocodeGeneratedDetail();
  },
  methods: {
    connectUser(item) {
      this.selectedItem = item;
      this.$refs.userModal.show();
    },
    handleSelectedCustomer(customer) {
      this.selectedItem.userId = customer.userId;
      this.connectUserWithPromocode();
    },
    async connectUserWithPromocode() {
      this.isBinding = true;
      const obj = {
        id: this.selectedItem.id,
        userId: this.selectedItem.userId,
      };
      const getData = await this.$services.promocode.bindingUserToPromocode(
        obj
      );

      if (getData.result == 1) {
        this.getPromocodeGeneratedDetail();
      }

      this.openModalAlertText(getData.message);

      this.isBinding = false;
    },
    async onClickHandleSearch() {
      await this.getPromocodeGeneratedDetail();
      this.closeSideBar();
    },
    resolveAndDownloadBlob(v, filename) {
      return this.$services.utils.resolveAndDownloadBlob(v, filename);
    },
    async getPromocodeGeneratedDetail() {
      const obj = {
        promocodeSerialNo: this.formSearch.promocodeSerialNo,
        isUseStatus: this.formSearch.isUseStatus,
        skip: this.filter.skip,
        take: this.filter.take,
      };
      const getData =
        await this.$services.promocode.getPromocodeGeneratedDetail(
          this.$route.params.id,
          obj
        );

      if (getData.result == 1) {
        this.items = getData.detail.data;
        this.rows = getData.detail.count;
      }
    },
    async exportPromocodeGeneratedDetail() {
      const obj = {
        promocodeSerialNo: this.formSearch.promocodeSerialNo,
        isUseStatus: this.formSearch.isUseStatus,
      };
      const getData =
        await this.$services.promocode.exportPromocodeGeneratedDetail(
          this.$route.params.id,
          obj
        );

      this.resolveAndDownloadBlob(getData, `PromocodeExport`);
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.skip = 1;
      this.filter.take = value;
      this.getPromocodeGeneratedDetail();
    },
    pagination(page) {
      this.filter.skip = page;
      this.filter.page = page;
      this.getPromocodeGeneratedDetail();
    },
    clearForm() {
      this.formSearch = {
        promocodeSerialNo: null,
        isUseStatus: null,
      };
    },
    clearFilter() {
      this.filter = {
        skip: 1,
        take: 10,
        page: 1,
      };

      this.clearForm();
      this.$refs.sidebarCheckCode.clearInput();
      this.getPromocodeGeneratedDetail();
    },
    openSideBar() {
      this.$refs.sidebarCheckCode.show();
    },
    closeSideBar() {
      this.$refs.sidebarCheckCode.hide();
    },
    openModalAlertText(text) {
      this.textModal = text;
      this.$bvModal.show("modal-alert-text");
    },
  },
};
</script>

<style lang="scss" scoped>
// ! OVERRIDE
.btn-filter {
  width: 100px;
}

.text-header {
  color: #092d53;
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
}

.g-form {
  flex: 1;
}
</style>
